(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Featured_NEW_collection"] && !window.DesignMode) return;
  try {
    
   $(document).on("click", ".select_pattern div", function() {
   $(this).addClass('active_pttrn').siblings().removeClass('active_pttrn');
   var text = $(this).text();
   $('.pop-up-pvcclick .modal__content div').each(function(){
   var newtext = $(this).attr('macth');
   if (newtext==text) {
       $(this).addClass('Active-text');
   } else if(newtext!=text) {
       $(this).removeClass('Active-text');
   }
   })

  $('.match-video .VIdeos').each(function(){
   var newtext1 = $(this).attr('macth');
    console.log(newtext1)
   if (newtext1==text) {
       $(this).addClass('Active-text');
   } else if(newtext1!=text){
       $(this).removeClass('Active-text');
   }
   })



   });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["popup_tips_tricks"] && !window.DesignMode) return;
  try {
    
    let popupTriggered = false;
    let userActive = false;
    let idleTime = 0;
    const delayTime = 30 * 1000; // 30 seconds
    const idleThreshold = 5 * 1000; // 5 seconds of inactivity

    // Function to show the popup

    function showPopup() {
      Shopify.analytics.publish('custom_event', {event: 'tips_popup_view'});
       console.log('showpopup')
        if (!popupTriggered) {
            document.querySelector(".popup_tips_tricks").style.display = "block";
           document.querySelector(".popup_tips_tricks").style.zIndex = "99999";
            document.querySelector(".popup_overlay").style.display = "block";
            popupTriggered = true;
            sessionStorage.setItem("popupShown", "true");
        }
    }



    // Function to reset idle timer on user activity
    function resetIdleTimer() {

        userActive = true;
        idleTime = 0;
    }

    // Detect user activity
    window.addEventListener("mousemove", resetIdleTimer);
    window.addEventListener("scroll", resetIdleTimer);
    window.addEventListener("touchmove", resetIdleTimer);
    window.addEventListener("touchstart", resetIdleTimer);

    // Check conditions periodically
    setInterval(() => {
        idleTime += 1000;
        if (idleTime < idleThreshold) {
            userActive = true;
        } else {
            userActive = false;
        }
    }, 1000);

  if (!sessionStorage.getItem("popupShown")) {
    const intervalId = setInterval(() => {
      console.log('idleeee');

      if (!popupTriggered && userActive) {
        if (!$('body').hasClass('index')) {
        showPopup();
        }
        clearInterval(intervalId); // now intervalId is defined
      } else {
        console.log('elsese');
      }
    }, delayTime);
  }



          function closePopup() {
                document.querySelector(".popup_tips_tricks").style.display = "none";
                document.querySelector(".popup_overlay").style.display = "none";
                console.log("Popup closed");
            }
        document.querySelector(".popup_overlay").addEventListener("click", function () {
            closePopup()
        });
        document.querySelector(".close_button_popup").addEventListener("click", function () {
            closePopup()
        });

  } catch(e) { console.error(e); }
})();
})();
